<template>
	<b-modal
		id="jobprefernce"
		centered
		hide-footer
		hide-header
		no-close-on-backdrop
		v-model="showModal"
		@hidden="$emit('close-modal')"
	>
		<div class="d-flex">
			<div class="candash-modal-left"></div>
			<div style="width: calc(100% - 60px)">
				<div class="candash-modal-top p-3">
					<div class="width-97">
						<div class="candash-modal-head">Job Preferences</div>
					</div>
					<div
						class="d-flex justify-content-end pointer"
						@click="$emit('close-modal')"
					>
						<img
							class="rotate-on-hover"
							src="@/assets/newdesign/dashboard/blueCross.svg"
							alt=""
						/>
					</div>
				</div>
				<div style="height: 270px" class="pr-4">
					<b-row class="mt-4 ml-3">
						<b-col>
							<div class="position-relative w-100 d-flex align-items-center">
								<InputField
									:id="'totalYearsOfExp'"
									:label="'Current CTC'"
									:type="'text'"
									:mandatory="false"
									:vmodel="formData.currentCTC"
									:placeholder="'Enter'"
									@select-value="updateCurrentCTC"
								/>
							</div>
						</b-col>
						<b-col>
							<div class="position-relative w-100 d-flex align-items-center">
								<InputField
									:id="'totalYearsOfExp'"
									:label="'Expected CTC'"
									:type="'text'"
									:mandatory="false"
									:vmodel="formData.expectedCTC"
									:placeholder="'Enter'"
									@select-value="updateExpectedCTC"
								/>
							</div>
						</b-col>
					</b-row>
					<b-row class="mt-4 ml-3">
						<b-col cols="6">
							<FormTags
								type="text"
								placeholder="Enter"
								id="123"
								fileFormat="text"
								:suggestions="[]"
								:vmodel="formData.willingToRelocateTo"
								@select-value="updateLocation"
								maxFileSize="5000"
								:label="'Preferred Locations'"
							/>
							<!-- <b-form-input
										v-model="formData.willingToRelocateTo"
										placeholder="Enter"
										type="text"
										class="laptopinput"
									/> -->
						</b-col>
						<b-col cols="6">
							<FormTags
								type="text"
								placeholder="Enter"
								id="123"
								fileFormat="text"
								:suggestions="[]"
								:vmodel="formData.languages"
								@select-value="updateLanguage"
								maxFileSize="5000"
								:label="'Languages Known'"
							/>
							<!-- <b-form-input
										v-model="formData.languages"
										placeholder="Enter"
										type="text"
										class="laptopinput"
									/> -->
						</b-col>
					</b-row>
					<b-row class="mt-4 ml-3">
						<b-col>
							<div class="position-relative">
								<SelectCustom
									placeholder="select"
									id="123"
									:values="values"
									:dropdown="true"
									:vmodel="formData.noticeKey"
									@select-value="updateNoticePeriod"
									:label="'Notice period'"
								/>
							</div>
						</b-col>
						<b-col>
							<div class="position-relative">
								<SelectCustom
									placeholder="select"
									id="123"
									:values="workType"
									:dropdown="true"
									:vmodel="formData.workKey"
									@select-value="updateWorkType"
									:label="'Work Type'"
								/>
							</div>
						</b-col>
					</b-row>
				</div>
				<div
					class="candash-modal-footer d-flex align-items-center justify-content-end"
				>
					<b-button
						class="candash-cancelBtn mr-3 pointer"
						@click="$emit('close-modal')"
						>Cancel</b-button
					>
					<div class="position-relative">
						<b-button
							class="candash-addBtn"
							:class="showLoader ? 'loader-class-update' : ''"
							@click="saveJobPreferences()"
							>{{ showLoader ? "" : showSave }}</b-button
						>
						<Loader class="loader-pos-job-pref" v-if="showLoader" />
					</div>
				</div>
			</div>
		</div>
	</b-modal>
</template>

<script>
import FormTags from "@/components/InputComponents/FormTags.vue";
import Loader from "@/components/fixedcomponents/Loader.vue";
import SelectCustom from "@/components/InputComponents/SelectCustom.vue";
import InputField from "@/components/InputComponents/Input.vue";
import { mapGetters } from "vuex";
import {
	saveJobPreference,
	getJobPreference,
} from "../../utils/apiFunctions.js";
import EventBus from "../../utils/EventBus";

export default {
	data() {
		return {
			showLoader: false,
			showPreferences: false,
			showSave: "Save",
			formData: {
				currentCTC: "",
				expectedCTC: "",
				willingToRelocateTo: [], // Changed to array since using FormTags
				languages: [], // Changed to array since using FormTags
				noticePeriod: "", // Will store selected value from SelectCustom
				noticeKey: "",
				workType: [], // Will store selected value from SelectCustom
				workKey: "",
			},
			values: [
				{ label: "Immediate", key: "immediate", seq: 1 },
				{ label: "15 Days", key: "15 Days", seq: 2 },
				{ label: "30 Days", key: "30 Days", seq: 3 },
				{ label: "60 Days", key: "60 Days", seq: 4 },
				{ label: "90 Days", key: "90 Days", seq: 5 },
				{
					label: "Currently on notice period",
					key: "currently on notice period",
					seq: 6,
				},
			],
			workType: [
				{
					label: "Hybrid",
					key: "hybrid",
					seq: 1,
				},
				{
					label: "Remote",
					key: "remote",
					seq: 2,
				},
				{
					label: "From Office",
					key: "fromOffice",
					seq: 3,
				},
			],
			showPref: this.showModal,
		};
	},
	props: {
		showModal: Boolean,
	},
	components: {
		FormTags,
		SelectCustom,
		Loader,
		InputField,
	},
	created() {
		this.getPreferences();
	},
	computed: {
		...mapGetters("userVUEX", {
			userinfo: "getUserInfo",
		}),
	},
	methods: {
		updateCurrentCTC(value) {
			this.formData.currentCTC = value;
		},
		updateExpectedCTC(value) {
			this.formData.expectedCTC = value;
		},
		numbersOnly(evt) {
			const charCode = evt.which || evt.keyCode;
			const allowedKeys = [46, 8, 9, 27, 13];
			const isControlKey = evt.keyCode === 65 && (evt.ctrlKey || evt.metaKey);
			const isArrowKey = evt.keyCode >= 35 && evt.keyCode <= 40;

			if (allowedKeys.includes(charCode) || isControlKey || isArrowKey) {
				return true;
			}
			if (charCode === 46) {
				if (
					this.formData.currentCTC?.includes(".") ||
					!this.formData.currentCTC
				) {
					evt.preventDefault();
					return false;
				}
				return true;
			}
			if (charCode < 48 || charCode > 57) {
				evt.preventDefault();
				return false;
			}

			return true;
		},
		validateInput(evt) {
			const value = evt.target?.value;
			if (value !== undefined && value !== null) {
				const newValue = value
					.replace(/[^\d.]/g, "")
					.replace(/(\..*)\./g, "$1");

				if (newValue !== value) {
					this.formData.currentCTC = newValue;
				}
			}
		},
		updateLocation(value) {
			this.formData.willingToRelocateTo = Array.isArray(value)
				? value
				: [value];
		},
		updateLanguage(value) {
			this.formData.languages = Array.isArray(value) ? value : [value];
		},
		updateNoticePeriod(value) {
			this.formData.noticePeriod = value;
		},
		updateWorkType(value) {
			this.formData.workType = [value];
		},
		async getPreferences() {
			try {
				const emailID = this.userinfo.email;
				const res = await getJobPreference(emailID);
				if (res.status == 200) {
					const data = res.data.data;
					if (data.submitted) {
						this.showSave = "Update";
						this.showPreferences = true;
						this.formData.currentCTC =
							data.currentCTC == 0 ? "" : data.currentCTC;
						this.formData.expectedCTC =
							data.expectedCTC == 0 ? "" : data.expectedCTC;
						this.formData.willingToRelocateTo = data.willingToRelocateTo;
						this.formData.languages = data.languages;
						this.formData.noticePeriod = data.noticePeriod;
						const selectedOption = this.values.find(
							(option) => option.key === data.noticePeriod
						);
						this.formData.noticeKey = selectedOption
							? selectedOption.key
							: null;
						this.formData.workType = data.workType;
						this.formData.workKey = data.workType[0];
					}
				}
			} catch {
				console.log("error");
			}
		},
		async saveJobPreferences() {
			try {
				this.showLoader = true;
				const emailID = this.userinfo.email;

				const payload = {
					email: emailID,
					currentCTC: parseFloat(this.formData.currentCTC) || 0,
					expectedCTC: parseFloat(this.formData.expectedCTC) || 0,
					willingToRelocateTo: this.formData.willingToRelocateTo,
					languages: this.formData.languages,
					noticePeriod: this.formData.noticePeriod,
					workType: this.formData.workType,
				};

				const response = await saveJobPreference(payload);

				if (response.status === 200) {
					EventBus.$emit("job-preference-updated");
					this.$emit("close-modal");
				}
			} catch (error) {
				console.error("Error saving job preferences:", error);
			}
		},
	},
};
</script>
<style>
.js-main-container {
	height: calc(100vh - 151px);
	display: flex;
	justify-content: space-between;
}

/* .js-left-cont {
	background-color: #ffffff;
	box-shadow: 0px 0px 14px 0px #c4c4c480;
	border-radius: 5px;
	height: 100%;
	width: 74.3%;
	padding: 11px 14px 9px 0px;
} */

.js-right-cont::-webkit-scrollbar {
	scroll-behavior: smooth;
	width: 0px !important;
	height: 0px !important;
	background-color: transparent !important;
}

.js-right-cont {
	-ms-overflow-style: none; /* IE and Edge */
	scrollbar-width: none; /* Firefox */
}

@media (min-width: 1536px) {
	.js-search-cont {
		border: 1px solid #c4c4c4;
		border-radius: 15px;
		width: 78%;
		transition: all 0.3s linear;
	}
}

/* Media query for mobile view */
@media only screen and (max-width: 1535px) {
	.js-search-cont {
		border: 1px solid #c4c4c4;
		border-radius: 15px;
		width: 74%;
		transition: all 0.3s linear;
	}

	.font9px {
		font-size: 9px !important;
	}

	.font10px {
		font-size: 10px !important;
	}
}

@media only screen and (max-width: 1395px) {
	.font9px {
		font-size: 7px !important;
	}

	.font10px {
		font-size: 8px !important;
	}
}

.js-input .form-control {
	width: 100%;
	border-width: 0px 1px 0px 0px;
	border-style: solid;
	border-color: #c4c4c4;
	border-radius: 15px 0px 0px 15px;
	padding: 8px 9px 12px 35px;
	height: 34px;
}

.js-input .form-control:focus {
	box-shadow: none;
}

.js-input .form-control::placeholder {
	color: #72738e80;
}

.js-search-pos {
	position: absolute;
	top: 9px;
	left: 11px;
}

.js-overflow {
	height: calc(100vh - 260px);
	overflow: auto;
}

.js-overflow-2 {
	height: calc(100vh - 230px);
	overflow: auto;
	padding: 0 15px 0 15px;
}

.js-cards {
	border: 1px solid #8c8c8c54;
	width: 100%;
	border-radius: 8px;
	padding: 11px 10px 11px 14px;
}

.js-selected-card {
	border: 1px solid #8c8c8c54;
	background-color: #e1eef7;
	width: 100%;
	border-radius: 8px;
	padding: 11px 10px 11px 14px;
}

.js-trans-main-cont {
	position: absolute;
	width: 44%;
	height: calc(100vh - 90px);
	right: 2px;
	top: 14px;
	z-index: 5;
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
}

.js-trans-top {
	padding: 20px 15px 12px 15px;
}

.js-trans-overflow {
	height: calc(100vh - 230px);
	display: flex;
	justify-content: space-between;
}

.js-trans-left {
	background-color: #e8eff4;
	border-radius: 4px;
	padding: 5px;
	width: 45%;
	height: 100%;
	overflow: auto;
}

.js-trans-right {
	width: 54%;
	border-radius: 4px;
	box-shadow: 0px 0.5px 10px 0px #28293d26;
	border: 0.5px solid #8c8c8c66;
	height: 100%;
	overflow: auto;
}

.js-normal-filter {
	font-family: "Montserrat", sans-serif;
	font-size: 13px;
	font-weight: 500;
	color: #344054;
	display: flex;
	align-items: center;
	padding: 10px;
}

.js-selected-filter {
	font-family: "Montserrat", sans-serif;
	font-size: 13px;
	font-weight: 500;
	color: #20639b;
	display: flex;
	align-items: center;
	padding: 10px;
	background-color: #ffffff;
	border-radius: 4px;
}

.js-right-first-card {
	background: linear-gradient(313.47deg, #c1d3fe 0.05%, #d7e3fc 79.13%);
	position: relative;
	width: 100%;
	/* height: 145px; */
	border-radius: 8px;
	overflow: hidden;
}

.js-right-jobpref-card {
	background: #ffffff;
	position: relative;
	width: 100%;
	/* height: 158px; */
	border-radius: 8px;
	overflow: hidden;
	border: 1px solid #dedede;
}

.firstside-pos {
	position: absolute;
	right: 0px;
	top: 0px;
	z-index: 1;
}

.js-right-input .form-control {
	background: #4a73d212;
	border: 1px solid #85a1e0;
	box-shadow: 0px 1px 2px 0px #1018280d;
	border-radius: 8px;
	height: 30px;
	padding: 10px 10px 12px 10px;
	color: #332d2d !important;
	font-size: var(--size-12) !important;
	font-weight: 500 !important;
}

.js-right-input .form-control:focus {
	background: #4a73d212;
	border: 1px solid #85a1e0;
	box-shadow: 0px 1px 2px 0px #1018280d;
	border-radius: 8px;
	height: 30px;
	padding: 10px 10px 12px 10px;
}

.js-assesspro-cards {
	background-color: #d8e9f7;
	box-shadow: 0px 4px 15px 0px #c4c4c480;
	width: 100%;
	border: 0.5px solid #ffffff;
	margin-bottom: 12px;
	padding: 10px;
	border-radius: 5px;
	position: relative;
	z-index: 2;
}

.carousel-assesspro-cards-1 {
	background-color: #ffffff;
	box-shadow: 0px 4px 15px 0px #c4c4c480;
	width: 49%;
	border: 1px solid #20639b33;
	margin-bottom: 12px;
	padding: 10px 10px 5px 10px;
	border-radius: 5px;
	position: relative;
	z-index: 2;
}

.carousel-assesspro-cards-2 {
	background-color: #f9fcfe;
	box-shadow: 0px 4px 15px 0px #c4c4c480;
	width: 49%;
	border: 1px solid #20639b33;
	margin-bottom: 12px;
	padding: 15px 10px 15px 15px;
	border-radius: 8px;
	position: relative;
	z-index: 2;
}

.js-purple-card {
	background-color: #f4ebfe;
	width: 100%;
	min-height: 300px;
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	border-radius: 8px;
}

.js-carousel-parent-2 {
	height: 115px;
}

.js-carousel-parent {
	height: 115px;
}

.js-carousel-parent .carousel {
	height: 100%;
}

.js-carousel-parent .carousel-inner {
	height: 100%;
}

.js-carousel-parent .carousel-item.active {
	height: 100%;
}

.js-carousel-parent .carousel-caption {
	display: flex;
	justify-content: space-between;
	z-index: 1;
	left: 0px;
	padding: 0;
	width: 99%;
	height: 100%;
	bottom: 0px;
}

.js-carousel-parent .carousel-control-prev {
	width: 6%;
	left: -12px;
	opacity: 1;
	top: 57px;
	height: fit-content;
}

.js-carousel-parent .carousel-control-next {
	width: 6%;
	right: -3px;
	opacity: 1;
	top: 57px;
	height: fit-content;
}

.js-carousel-parent .carousel-control-prev-icon {
	background-image: url("../../assets/newdesign/jobsearch/carouselLeft.svg") !important;
	width: 40px;
	height: 40px;
	transform: rotate(0deg);
	left: unset !important;
	position: absolute;
	top: unset !important;
}

.js-carousel-parent .carousel-control-next-icon {
	background-image: url("../../assets/newdesign/jobsearch/carouselRight.svg") !important;
	width: 40px;
	height: 40px;
	transform: rotate(0deg);
	right: unset !important;
	position: absolute;
	top: unset !important;
}

.js-carousel-parent-2 .carousel {
	height: 100%;
}

.js-carousel-parent-2 .carousel-inner {
	height: 100%;
}

.js-carousel-parent-2 .carousel-item.active {
	height: 100%;
}

.js-carousel-parent-2 .carousel-caption {
	display: flex;
	justify-content: space-between;
	z-index: 1;
	left: 0px;
	padding: 0;
	width: 99%;
	height: 100%;
	bottom: 0px;
}

.js-carousel-parent-2 .carousel-control-prev {
	width: 6%;
	left: -12px;
	opacity: 1;
	top: 35px;
	height: fit-content;
}

.js-carousel-parent-2 .carousel-control-next {
	width: 6%;
	right: -3px;
	opacity: 1;
	top: 35px;
	height: fit-content;
}

.js-carousel-parent-2 .carousel-control-prev-icon {
	background-image: url("../../assets/newdesign/jobsearch/carouselLeft.svg") !important;
	width: 40px;
	height: 40px;
	transform: rotate(0deg);
	left: unset !important;
	position: relative;
	top: unset !important;
}

.js-carousel-parent-2 .carousel-control-next-icon {
	background-image: url("../../assets/newdesign/jobsearch/carouselRight.svg") !important;
	width: 40px;
	height: 40px;
	transform: rotate(0deg);
	right: unset !important;
	position: relative;
	top: unset !important;
}
.loader-pos-withdraw {
	position: absolute;
	top: -53px;
	z-index: 1;
	left: 20px;
}
.loader-class-withdraw {
	height: 31.5px !important;
	width: 130.5px !important;
	opacity: 0.5;
}
.highlight {
	font-weight: bold;
	background-color: yellow;
}
.jobpref-subheads {
	font-family: "Montserrat", sans-serif;
	font-style: italic;
	font-weight: 400;
	font-size: 13px;
	color: #4e4e4e;
}
.setupbtn {
	border-radius: 8px !important;
	padding: 3px 15px !important;
}

#jobprefernce .modal-body {
	padding: 0px !important;
}
#jobprefernce .modal-content {
	top: 30px !important;
}
#jobprefernce .modal-dialog {
	max-width: 950px !important;
}
</style>
